import { useState, useEffect } from "react";
import Header from "../../components/header";
import ListaProdutos from "../../components/listaprodutos";
import ModalNotProduct from "../../components/modalnotproduct";
import ModalTimeout from "../../components/modaltimeout";
import MenuLateral from "../../components/MenuLateral";
import {
  Box,
  Button,
  Fab,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Modal,
  OutlinedInput,
  Radio,
  Skeleton,
  SwipeableDrawer,
} from "@mui/material";
import apiConnect from "../../api/apiConnect";
import ListaProdutosDetails from "../../components/listaprodutosDetails";
import Iconbag from "../../componentsStyled/icon/Iconbag";
import ChatFlutuant from "../../components/ChatFlutuant";
import HeaderMobile from "../../components/headerMobile";
import { isMobile } from "react-device-detect";
import MiniStepper from "../../components/miniStepper";

interface Pedido {
  id: string;
  date: string;
  remaining_days: number;
  product_image: string;
  hour: string;
  shipment_date: string;
  delivery_date: string;
  is_traceable: string;
  PickupLocation: Array<any>;
  Extensions: Array<any>;
  old_order: boolean;
  exception: boolean;
  active: boolean;
}
type auth = {
  basicAuth: string;
  code: number;
  email: string;
  customerId: string;
  token: string;
};

export default function Order() {
  const [dataPedidos, setDataPedidos] = useState<Pedido[]>([]);
  const [selectedId, setSelectedId] = useState("#");
  const [showModal, setShowModal] = useState(false);
  const [modalIsOpen, setOpenmodal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [modalDetails, setModalDetail] = useState(false);
  const [modalProduct, setModalProduct] = useState(false);

  const [pedidoSelect, setPedidoSelect] = useState<any>(undefined);
  const [searchTerm, setSearchTerm] = useState<any>("");
  const [searchResult, setSearchResult] = useState<any[]>([]);

  const openModal = () => {
    setOpenmodal(true);
  };
  const closeModal = () => {
    setOpenmodal(false);
  };

  const handleGetPedidos = async () => {
    setLoading(true);
    let auth = localStorage.getItem("auth");
    if (!auth) {
      openModal();
      return;
    }
    if (auth.length > 0) {
      const authObj: auth = JSON.parse(auth);
      apiConnect.apiAPP
        .get("/order/list/" + authObj.customerId, {
          headers: {
            Authorization: "Basic " + authObj.basicAuth,
          },
        })
        .then((response) => {
          setLoading(false);
          if (response.data.length == 0) {
            setShowModal(true);
          } else {
            setDataPedidos(response.data);
          }
        })
        .catch((error) => {
          setLoading(false);
          if (error.response && error.response.status === 401) {
            localStorage.removeItem("auth");
            openModal();
          } else {
            // Handle other errors if needed
            console.log(error);
          }
        });
    } else {
      setLoading(false);
      openModal();
    }
  };

  const handleSearch = () => {
    const filteredDevolucoes = dataPedidos.filter((pedidos) => {
      if (String(pedidos.id).indexOf(searchTerm) > -1) {
        return pedidos;
      }
    });
    setSearchResult(filteredDevolucoes);
  };

  const formatDate = (dateTimeString: string) => {
    const options: Intl.DateTimeFormatOptions = { year: "numeric", month: "numeric", day: "numeric" };
    return new Date(dateTimeString).toLocaleDateString("pt-BR", options);
  };

  const BoxProduct = (pedidoData) => {
    const pedido: Pedido = pedidoData.pedido;
    return (
      <Box width={{ xs: "43vw", md: 300 }} mt={5}>
        <Box position={"relative"}>
          <img style={{ width: "100%", borderRadius: 15 }} src={pedido.product_image} alt="produtoImg" />
          <Box position={"absolute"} top={0} right={-12} zIndex={1}>
            <FormControlLabel
              control={<Radio color="error" />}
              label=""
              onClick={() => setPedidoSelect(pedido.id)}
              checked={pedidoSelect === pedido.id ? true : false}
            />
          </Box>
          <Box
            sx={{
              position: "absolute",
              bottom: 10,
              left: 5,
              backgroundColor: "#fff",
              display: "flex",
              flexDirection: "row",
              padding: 1,
              borderRadius: 10,
              // width: 75,
              gap: 1,
            }}>
            {pedido.remaining_days > 0 ? (
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.226 14.606q-1.384 0-2.6-.524a6.8 6.8 0 0 1-2.118-1.426q-.9-.9-1.424-2.116a6.5 6.5 0 0 1-.526-2.6q0-1.382.526-2.6.524-1.218 1.424-2.116t2.118-1.426a6.5 6.5 0 0 1 2.6-.524q1.38 0 2.6.524 1.216.526 2.116 1.426t1.424 2.116.526 2.6q0 .45-.05.884a6 6 0 0 1-.166.85 2.2 2.2 0 0 0-.542-.45 2 2 0 0 0-.676-.25 5.2 5.2 0 0 0 .1-1.034q0-2.232-1.55-3.784a5.14 5.14 0 0 0-3.782-1.55q-2.234 0-3.784 1.55a5.14 5.14 0 0 0-1.55 3.784q0 2.232 1.55 3.784a5.14 5.14 0 0 0 3.784 1.55q.85 0 1.624-.25a5.4 5.4 0 0 0 1.426-.7q.2.28.49.5.294.216.626.332a6.6 6.6 0 0 1-4.166 1.45m4.832-2.666a.8.8 0 0 1-.592-.24.8.8 0 0 1-.24-.594q0-.348.24-.592.244-.24.592-.24.352 0 .592.24.24.244.242.592 0 .352-.24.592-.244.24-.594.242m-2.632-.866L7.558 8.206v-3.6h1.334v3.068l2.466 2.466z"
                  fill="#1C1B1F"
                />
              </svg>
            ) : null}
            <p style={{ fontWeight: 400, fontSize: 14 }}>{pedido.remaining_days > 0 ? `${pedido.remaining_days} Dias` : `Encerrado`}</p>
          </Box>
        </Box>

        <Box pl={2} pr={2} display={"flex"} flexDirection={"column"} gap={1}>
          <p style={{ fontSize: 14, fontWeight: 500 }}>Pedido #{pedido.id}</p>
          <p style={{ fontSize: 14, fontWeight: 300 }}>{formatDate(pedido.delivery_date)}</p>
          <Button
            variant="outlined"
            onClick={() => {
              setModalDetail(true);
              setSelectedId(pedido.id);
            }}
            style={{
              borderRadius: 100,
              color: "#000",
              borderColor: "#000",
              display: "block",
              margin: "0 auto",
              width: "100%",
            }}>
            Ver mais
          </Button>
        </Box>
      </Box>
    );
  };

  useEffect(() => {
    handleGetPedidos();
  }, []);
  return (
    <>
      {/* desktop */}
      <Box display={{ xs: "none", md: "initial" }}>
        <Header />
        <Box display={"flex"} width={"100%"} justifyContent={"center"} mt={5}>
          <MenuLateral currentPage="request" />
          <Box width={"100%"} ml={2}>
            {loading ? (
              <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                <Skeleton variant="rounded" width={300} height={100} />
                <Skeleton variant="rounded" width={"100%"} height={300} />
              </div>
            ) : (
              <Box>
                <p style={{ fontSize: 22 }}>Selecione o pedido</p>
                <Box display={"flex"} width={"90%"} justifyContent={"right"}>
                  <MiniStepper step={1} />
                </Box>
                <Box ml={4}>
                  <p style={{ fontSize: 15, marginTop: 10, marginBottom: 10 }}>Busca</p>
                  <FormControl variant="outlined" style={{ width: "45%" }}>
                    <OutlinedInput
                      placeholder="Procure por um pedido"
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                      }}
                      onKeyDown={handleSearch}
                      sx={{ bgcolor: "#F3F3F3", borderRadius: 5, width: "100%" }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setSearchTerm("");
                              setSearchResult([]);
                            }}
                            edge="end">
                            {searchTerm.length > 0 ? (
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="m7.829 9.582-5.6 5.6a1.1 1.1 0 0 1-.8.315 1.1 1.1 0 0 1-.8-.313 1.1 1.1 0 0 1-.315-.8q0-.487.315-.8l5.6-5.6-5.6-5.6a1.1 1.1 0 0 1-.315-.8q0-.487.315-.8a1.1 1.1 0 0 1 .8-.316q.485 0 .8.315l5.6 5.6 5.6-5.6a1.1 1.1 0 0 1 .8-.315q.485 0 .8.315a1.1 1.1 0 0 1 .315.8 1.1 1.1 0 0 1-.315.8l-5.6 5.6 5.6 5.6a1.1 1.1 0 0 1 .315.8 1.1 1.1 0 0 1-.315.8 1.1 1.1 0 0 1-.8.315 1.1 1.1 0 0 1-.8-.313z"
                                  fill="#1C1B1F"
                                />
                              </svg>
                            ) : (
                              <svg width="32" height="32" viewBox="-0.08 0 0.76 0.76" xmlns="http://www.w3.org/2000/svg">
                                <path d="M.566.62a.04.04 0 0 1-.062 0L.368.484A.224.224 0 1 1 .43.422l.136.136a.04.04 0 0 1 0 .062M.312.464a.18.18 0 1 0-.068.014.2.2 0 0 0 .068-.014" />
                              </svg>
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>

                  {/* listagem dos pedidos */}
                  <Box display={"flex"} flexDirection={"row"} flexWrap={"wrap"} alignItems={"center"} gap={2}>
                    {searchResult.length > 0
                      ? searchResult.map((pedido, i) => <BoxProduct key={i} pedido={pedido} />)
                      : dataPedidos.length > 0
                        ? dataPedidos.map((pedido, i) => <BoxProduct key={i} pedido={pedido} />)
                        : <p></p>
                    }
                  </Box>
                  {/* listagem dos pedidos */}
                </Box>
              </Box>
            )}
            <Button
              onClick={() => setModalProduct(true)}
              disabled={!pedidoSelect ? true : false}
              variant="contained"
              style={{
                marginTop: 40,
                marginBottom: 10,
              }}
              sx={{
                width: "30%",
                borderRadius: 100,
                margin: "0 auto",
                display: "block",
                backgroundColor: "#221F20",
                "&:hover": {
                  backgroundColor: "#908F8F",
                  color: "#fff",
                },
              }}>
              Confirmar
            </Button>
          </Box>
        </Box>
      </Box>
      {/* desktop */}

      {/* mobile */}
      <Box display={{ xs: "initial", md: "none" }}>
        <HeaderMobile currentPage="request" />
        <Box ml={2} mr={2}>
          {loading ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <Skeleton variant="rounded" width={"50%"} height={100} />
              <Skeleton variant="rounded" width={"100%"} height={300} />
            </div>
          ) : (
            <>
              <Box display={"flex"} width={"100%"} justifyContent={"center"} mb={2}>
                <MiniStepper step={1} />
              </Box>
              <p style={{ fontSize: 22 }}>Selecione o pedido</p>
              <p style={{ fontSize: 15, marginTop: 10, fontWeight: 300 }}>Busca</p>

              <FormControl variant="outlined" style={{ width: "100%" }}>
                <OutlinedInput
                  placeholder="Procure por um pedido"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                  onKeyDown={handleSearch}
                  sx={{ bgcolor: "#F3F3F3", borderRadius: 5, width: { xs: "100%", md: "50%" } }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setSearchTerm("");
                          setSearchResult([]);
                        }}
                        edge="end">
                        {searchTerm.length > 0 ? (
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="m7.829 9.582-5.6 5.6a1.1 1.1 0 0 1-.8.315 1.1 1.1 0 0 1-.8-.313 1.1 1.1 0 0 1-.315-.8q0-.487.315-.8l5.6-5.6-5.6-5.6a1.1 1.1 0 0 1-.315-.8q0-.487.315-.8a1.1 1.1 0 0 1 .8-.316q.485 0 .8.315l5.6 5.6 5.6-5.6a1.1 1.1 0 0 1 .8-.315q.485 0 .8.315a1.1 1.1 0 0 1 .315.8 1.1 1.1 0 0 1-.315.8l-5.6 5.6 5.6 5.6a1.1 1.1 0 0 1 .315.8 1.1 1.1 0 0 1-.315.8 1.1 1.1 0 0 1-.8.315 1.1 1.1 0 0 1-.8-.313z"
                              fill="#1C1B1F"
                            />
                          </svg>
                        ) : (
                          <svg width="32" height="32" viewBox="-0.08 0 0.76 0.76" xmlns="http://www.w3.org/2000/svg">
                            <path d="M.566.62a.04.04 0 0 1-.062 0L.368.484A.224.224 0 1 1 .43.422l.136.136a.04.04 0 0 1 0 .062M.312.464a.18.18 0 1 0-.068.014.2.2 0 0 0 .068-.014" />
                          </svg>
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>

              {/* listagem dos pedidos */}
              <Box display={"flex"} flexDirection={"row"} flexWrap={"wrap"} alignItems={"center"} justifyContent={"center"} gap={"14px"} pb={10}>
                {searchResult.length > 0
                  ? searchResult.map((pedido, i) => <BoxProduct key={i} pedido={pedido} />)
                  : dataPedidos.length > 0
                    ? dataPedidos.map((pedido, i) => <BoxProduct key={i} pedido={pedido} />)
                    : <p></p>
                }
              </Box>
              {/* listagem dos pedidos */}
            </>
          )}
          <Button
            onClick={() => setModalProduct(true)}
            disabled={!pedidoSelect ? true : false}
            variant="contained"
            sx={{
              position: "fixed",
              bottom: 30,
              left: 0,
              right: 0,
              width: "57%",
              borderRadius: 100,
              margin: "0 auto",
              display: "block",
              backgroundColor: "#221F20",
              "&:hover": {
                backgroundColor: "#908F8F",
                color: "#fff",
              },
            }}>
            Confirmar
          </Button>
        </Box>
      </Box>
      {/* mobile */}

      {/* space */}
      {/* <Box marginY={30} /> */}
      {/* space */}

      <ModalTimeout isOpen={modalIsOpen} onRequestClose={closeModal} />
      <ModalNotProduct isOpen={showModal} />

      {/* modal pedido details */}
      {isMobile ? (
        <SwipeableDrawer
          anchor="bottom"
          open={modalDetails}
          onClose={() => setModalDetail(false)}
          onOpen={() => setModalDetail(true)}
          swipeAreaWidth={0}
          disableSwipeToOpen={false}
          keepMounted
          sx={{
            "& .MuiDrawer-paper": {
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
            },
          }}>
          <Box
            sx={{
              width: "20%",
              height: 5,
              backgroundColor: "#8C95A9",
              borderRadius: 10,
              margin: "5px auto",
            }}
          />
          <Box display={"flex"} flexDirection={"column"} gap={2} pl={2} pr={2}>
            <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
              <Box display={"flex"} alignItems={"center"} gap={1}>
                <Iconbag width={35} />
                <p style={{ fontSize: 20, fontWeight: 900, fontFamily: "Helvetica Neue" }}>Meu Pedido</p>
              </Box>
              <Fab onClick={() => setModalDetail(false)} sx={{ backgroundColor: "#fff", boxShadow: "none", fontSize: 20, fontWeight: 900 }}>
                X
              </Fab>
            </Box>
            <Box mt={3} height={{ xs: "70vh", md: "initial" }} overflow={"auto"}>
              {dataPedidos.length > 0 && <ListaProdutosDetails selectedId={selectedId} />}
            </Box>
            <Button
              onClick={() => setModalDetail(false)}
              variant="outlined"
              style={{ display: "block", margin: "10px auto", width: "80%", borderRadius: 64, color: "#000", borderColor: "#000" }}
              sx={{
                marginBottom: 10,
              }}>
              Fechar
            </Button>
          </Box>
        </SwipeableDrawer>
      ) : (
        <Modal
          open={modalDetails}
          onClose={() => {
            setModalDetail(false);
          }}
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            width: { xs: "100%", md: "50%" },
            height: { xs: "95%", md: "fit-content" },
            transform: "translate(-50%, -50%)",
            padding: "10px 20px",
            bgcolor: "#fff",
            boxShadow: 24,
            "& .MuiBackdrop-root": { backgroundColor: "transparent" },
            display: "flex",
            flexDirection: "column",
            borderRadius: 5,
          }}>
          <Box display={"flex"} flexDirection={"column"} gap={2} padding={2}>
            <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
              <Box display={"flex"} alignItems={"center"} gap={1}>
                <Iconbag width={35} />
                <p style={{ fontSize: 20, fontWeight: 900, fontFamily: "Helvetica Neue" }}>Meu Pedido</p>
              </Box>
              <Fab onClick={() => setModalDetail(false)} sx={{ backgroundColor: "#fff", boxShadow: "none", fontSize: 20, fontWeight: 900 }}>
                X
              </Fab>
            </Box>
            <Box mt={3} height={{ xs: "70vh", md: "initial" }} overflow={"auto"}>
              {dataPedidos.length > 0 && <ListaProdutosDetails selectedId={selectedId} />}
            </Box>
            <Button
              onClick={() => setModalDetail(false)}
              variant="outlined"
              style={{ display: "block", margin: "0 auto", width: "40%", height: 55, borderRadius: 64, color: "#000", borderColor: "#000" }}>
              Fechar
            </Button>
          </Box>
        </Modal>
      )}
      {/* modal pedido details */}

      {/* modal select products from pedido */}
      {isMobile ? (
        <SwipeableDrawer
          anchor="bottom"
          open={modalProduct}
          onClose={() => setModalProduct(false)}
          onOpen={() => setModalProduct(true)}
          swipeAreaWidth={0}
          disableSwipeToOpen={false}
          keepMounted
          // aplicar borderradius
          sx={{
            "& .MuiDrawer-paper": {
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
            },
          }}>
          <Box
            sx={{
              width: "20%",
              height: 5,
              backgroundColor: "#8C95A9",
              borderRadius: 10,
              margin: "5px auto",
            }}
          />
          <Box pl={2} pr={2}>
            <Box display={"flex"} justifyContent={"flex-end"}>
              <Fab onClick={() => setModalProduct(false)} sx={{ backgroundColor: "#fff", boxShadow: "none", fontSize: 20, fontWeight: 500, height: 15 }}>
                X
              </Fab>
            </Box>
            <Box display={"flex"} alignItems={"center"} gap={1} mb={3}>
              <Iconbag width={35} />
              <p style={{ fontSize: 20, fontWeight: 500, fontFamily: "Helvetica Neue" }}>Meu Pedido</p>
            </Box>
            <ListaProdutos selectedId={pedidoSelect} />
          </Box>
        </SwipeableDrawer>
      ) : (
        <Modal
          open={modalProduct}
          onClose={() => setModalProduct(false)}
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            width: "30%",
            height: "fit-content",
            transform: "translate(-50%, -50%)",
            padding: "10px 15px",
            bgcolor: "#fff",
            boxShadow: 24,
            "& .MuiBackdrop-root": { backgroundColor: "transparent" },
            display: "flex",
            flexDirection: "column",
            borderRadius: 5,
          }}>
          <Box>
            <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
              <Box display={"flex"} alignItems={"center"} gap={1}>
                <Iconbag width={35} />
                <p style={{ fontSize: 20, fontWeight: 900, fontFamily: "Helvetica Neue" }}>Meu Pedido</p>
              </Box>
              <Fab onClick={() => setModalProduct(false)} sx={{ backgroundColor: "#fff", boxShadow: "none", fontSize: 20, fontWeight: 500 }}>
                X
              </Fab>
            </Box>
            <ListaProdutos selectedId={pedidoSelect} />
          </Box>
        </Modal>
      )}
      {/* modal select products from pedido */}

      <ChatFlutuant />
    </>
  );
}
